<template>
  <div>
    <div id="printTable" style="">
      <div class="noprint printTableTitle">
        <h2>物资领用 采购单</h2>
      </div>
      <List border size="small" style="margin-bottom: 20px; position: relative">
        <div class="ma">
          <el-image
            style="width: 100px; height: 100px; margin-left: 5px"
            :src="caiurl"
            :initial-index="0"
            fit="cover"
            :preview-src-list="previewSrcList(caiurl)"
          >
            <div slot="error" class="image-slot">
              <img src="../../assets/img/pictureSplit.png" />
            </div>
          </el-image>
          <p style="font-size: 12px">请扫码填写发货信息</p>
        </div>
        <ListItem>
          <Col span="3">
            <div class="printTableLeft">采购工单编号:</div>
          </Col>
          <Col span="21">{{ info.purchaseNo }}</Col>
        </ListItem>
        <ListItem>
          <Col span="3">
            <div class="printTableLeft">事由:</div>
          </Col>
          <Col span="21">
            {{ info.cause == null ? "无" : info.cause }}
          </Col>
        </ListItem>
        <ListItem>
          <Col span="3" class="printTableLeft">
            <div class="printTableLeft">期望交付日期:</div>
          </Col>
          <Col span="21">{{ info.deliveryDate }}</Col>
        </ListItem>
        <ListItem>
          <Col span="3" class="printTableLeft">
            <div class="printTableLeft">收货信息:</div>
          </Col>
          <Col span="21">{{
            info.goodsReceivingInformation ? info.goodsReceivingInformation : ""
          }}</Col>
        </ListItem>
        <!--  <ListItem class="noprint" style="align-items: start">
          <Col span="3">
            <div class="printTableLeft">物资信息:</div>
          </Col>
          <Col span="21">
            <div class="printTableRight">
              <div
                class="printTableRightText"
                v-for="(item, index) in tabledata"
                :key="item.id"
              >
                {{ index + 1 }}.{{ item.brand }} {{ item.name }} / 型号：{{
                  item.model
                }}
                * {{ item.alertNum }}{{ item.unit }}
              </div>
            </div>
          </Col>
        </ListItem> -->
        <ListItem>
          <Col span="3" class="printTableLeft">
            <div class="printTableLeft">总价:</div>
          </Col>
          <Col span="21">{{ info.totalPrices }}</Col>
        </ListItem>
        <ListItem>
          <Col span="3" class="printTableLeft">
            <div class="printTableLeft">优惠后总价:</div>
          </Col>
          <Col span="21">{{ info.discountsPrices }}</Col>
        </ListItem>
        <ListItem>
          <Col span="3" class="printTableLeft">
            <div class="printTableLeft" v-if="this.customerId != 0">供应商:</div>
            <div class="printTableLeft" v-if="this.customerId == 0">客户:</div>
          </Col>
          <Col span="21">{{ fuwuinfo }}</Col>
        </ListItem>
        <div class="printTableLeft">
          <Table
            :columns="tableCols"
            :data="tabledata"
            :table="table"
            :border="table.border"
            :stripe="table.stripe"
            :header="table.header"
            :footer="table.footer"
            :columns-list="tableCols"
          >
          </Table>
        </div>
      </List>
      <!--  <div class="noprints">
        <Table
          :columns="tableCols"
          :data="tabledata"
          :table="table"
          :border="table.border"
          :stripe="table.stripe"
          :header="table.header"
          :footer="table.footer"
          :columns-list="tableCols"
        >
        </Table>
      </div> -->
    </div>
    <div style="margin-top: 10px">
      <Button style="margin-left: 10px" type="primary" v-print="printObject">打印</Button>
    </div>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
import logo from "../../assets/logo.png";

let customerId = window.localStorage.getItem("customerId")
export default {
  name: "orderInfo",
  props: {
    kv: null,
    workId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      customerId : "",
      fuwuinfo: "",
      caiurl: "",
      printObject: {
        id: "printTable",
        popTitle: "物资领用 送货/签收单", // 打印配置页上方的标题
      },
      info: {},
      tabledata: [],
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          minWidth: 600,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  height: "80px",
                  display: "flex",
                  justifyContent: "flex-start",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                  },
                  attrs: {
                    src:
                      p.row.consumableImgUrl == "" || p.row.consumableImgUrl == null
                        ? logo
                        : IMAGE_HOST + p.row.consumableImgUrl,
                  },
                }),
                h(
                  "div",
                  {
                    style: {
                      marginTop: "10px",
                      textAlign: "left",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  },
                  [
                    h(
                      "p",
                      {
                        domProps: {
                          title: p.row.brand + p.row.name,
                        },
                      },
                      p.row.brand + p.row.name
                    ),

                    h(
                      "p",
                      {
                        style: {
                          display: p.row.model == null ? "none" : "block",
                        },
                        domProps: {
                          title: "型号:" + p.row.model,
                        },
                      },
                      "型  号: " + p.row.model
                    ),
                    h(
                      "p",
                      {
                        style: {
                          width: "500px",
                          textAlign: "left",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: p.row.remark == null ? "none" : "block",
                        },
                        domProps: {
                          title: "适用于: " + p.row.remark,
                        },
                      },
                      "适用于: " + p.row.remark
                    ),
                  ]
                ),
              ]
            );
          },
        },
        {
          title: "单价",
          key: "unitPrice",
          minWidth: 60,
          align: "center",
        },
        {
          title: "采购数",
          minWidth: 60,
          key: "alertNum",
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 60,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            console.log(row);
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
      ],
    };
  },
  created() {
    this.customerId = customerId
    if (this.workId) {
      this.initData(this.workId);
    }
  },
  methods: {
    previewSrcList(url) {
      var list = [];
      list.push(url);
      return list;
    },
    errorHandler() {
      return true;
    },
    initData(workId, page = 1) {
      // 加载详情工单数据
      let id = workId;
      $utils.api.load(`/admin/system/inventory/${id}`, {}).then((res) => {
        if (res && res.data) {
          let data = res.data;
          this.info = data.sysConsumableReceivePurchaseResponse;
          let caiinfo = data.sysConsumableReceivePurchaseResponse;
          if (caiinfo != null) {
            this.caiurl = caiinfo.purchaseUrl
              ? caiinfo.purchaseUrl.includes("http")
                ? caiinfo.purchaseUrl
                : IMAGE_HOST + caiinfo.purchaseUrl
              : caiinfo.purchaseUrl;
          }
          let arr = data.sysConsumableReceiveDetails;
          for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            let obj = {};
            obj.consumableImgUrl = item.consumableImgUrl
              ? item.consumableImgUrl
              : "src\assets\logo.min.png";
            obj.brand = item.brand;
            obj.name = item.inventoryName;
            obj.model = item.model;
            obj.remark = item.remark;
            obj.unit = item.unit;
            obj.alertNum = item.alterNum;
            obj.unitPrice = item.unitPrice;
            this.tabledata.push(obj);
          }
          this.fuwu(caiinfo.supplierId);
        }
      });
    },
    fuwu(id) {
      $utils.api.load(`/admin/system/supplier/${id}`, {}).then((res) => {
        if (res && res.data) {
          let data = res.data;
          let a =
            data.supplierName == null || data.supplierName == "" ? "" : data.supplierName;
          let b =
            data.legalRepresentative == null || data.legalRepresentative == ""
              ? ""
              : data.legalRepresentative;
          let c = data.phone == null || data.phone == "" ? "" : data.phone;
          this.fuwuinfo = a + "-" + b + "-" + c;
        }
      });
    },
  },
};
</script>
<style lang="less">
#printTable .noprint {
  display: none;
}

.ma {
  position: absolute;
  top: 5px;
  right: 0;
  justify-content: flex-end;
  z-index: 9;
}

.printTableTitle {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 20px;
}

.printTableLeft {
  font-weight: 600;
}

.printTableRight {
  width: 100%;

  .printTableRightText {
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap;
    margin-top: 10px;
  }

  .printTableRightText:nth-child(1) {
    margin-top: 0;
  }
}

@media print {
  #printTable .noprint {
    display: flex !important;
  }

  .noprints {
    display: none;
  }
}
</style>
